import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Dashboard.scss";
import { Box, Grid, Tab, Tabs, Typography } from "@material-ui/core";
import { Text, SelectBox, SVG } from "sunrise-ui";
import PropTypes from "prop-types";
// import dateFormat from "../../utilities/dateFormat";

// Pages for tabs
import WorkInProgressPiles from "./WorkInProgressPiles";
import CompletedPiles from "./CompletedPiles";

// ------for table--------------
import { makeStyles } from "@material-ui/core/styles";

// --------API----------------
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { getAllMachineData } from "../../redux/reducers/machineReducers";
import { getProjectPilesInfo } from "../../redux/reducers/projectReducers";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import Loader from "../../utilities/Loader";
import Discarded from "./Discarded";
import CurrentEngineersAtSite from "./CurrentEngineersAtSite";
import TotalManpower from "./TotalManpower";
import {
  getOverAllStatusOfProject,
  getUsersInProject,
  getWIPPiles,
  getAvailableMachines,
  getEngineersInShift,
  getCompletedPilesTableData,
  getDiscardedPilesData,
  getTotalEmployees,
  getPileDetails,
} from "../../redux/reducers/dashboardReducers";
import { getApprovedPendingBills } from "../../redux/reducers/billReducer";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import { getRank } from "../../redux/reducers/users";

export const HeadLines: React.FC<{
  label: string;
  value: any;
  icon: any;
  fontSize: number;
}> = (props) => {
  return (
    <Grid className="d-flex bg--white box--shadow p mr-1">
      <span>
        <SVG type={props.icon} />
      </span>
      <Grid className="flexbox-between">
        <Text
          type="normal"
          fonts="normal"
          fontSize={props.fontSize}
          className="mb0 mt0 fw400"
        >
          <span>{props.label}:</span>
        </Text>
        <Text
          type="normal"
          fonts="normal"
          fontSize={props.fontSize}
          className="mb0 mt0 ml fw400"
        >
          <span className="fw300"> {props.value} </span>
        </Text>
      </Grid>
    </Grid>
  );
};

function TabPanel({ children, value, index, ...other }: any) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
}));

const Dashboard = () => {
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const classes = useStyles();

  const allProject = useSelector((state: any) => state.PROJECT.allProjectData);
  const { wipCount, discardedCount, completedCount } = useSelector(
    (state: any) => state.DASHBOARD.pileDetails
  );
  const { approved, pending } = useSelector(
    (state: any) => state.BILLS.pendingAndApprovedBills
  );
  const engsInShifData = useSelector(
    (state: any) => state.DASHBOARD.engineersInShift
  );
  const WIPPiles = useSelector((state: any) => state.DASHBOARD.WIPPiles);
  const totalEmployeesCount = useSelector(
    (state: any) => state.DASHBOARD.totalEmployeesCount
  );
  const { discardRejectPiles } = useSelector(
    (state: any) => state.PROJECT.pilesInfo
  );

  const completedPilesTableData = useSelector(
    (state: any) => state.DASHBOARD.completedPilesTableData
  );
  const allMachineData = useSelector(
    (state: any) => state?.MACHINE?.allMachineData
  );
  const [projectList, setProjectList] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [value, setValue] = React.useState(0);
  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const getWIPPilesData = (id: any) => {
    dispatch(
      getWIPPiles({
        endPoint: `piles/wipPiles?project=${id}`,
      })
    );
  };
  const getCompletedPiles = (id: any) => {
    dispatch(
      getCompletedPilesTableData({
        endPoint: `piles?status=COMPLETED&project=${id}`,
      })
    );
  };
  const getDiscardData = (id: any) => {
    dispatch(
      getDiscardedPilesData({
        endPoint: `piles/get-discarded?projectId=${id}`,
      })
    );
  };
  const getAllUsers = (id: any) => {
    dispatch(
      getUsersInProject({
        endPoint: `general/users/${id}`,
      })
    );
    dispatch(
      getAvailableMachines({
        endPoint: `project/get-machines/${id}`,
      })
    );
  };

  const getPilesInfoData = (id: any) => {
    dispatch(
      getProjectPilesInfo({
        endPoint: `piles/pile-details-project-info?projectId=${id}`,
      })
    );
  };

  useEffect(() => {
    dispatch(
      getAllProjectData({
        endPoint: `project/get-all-projects`,
      })
    );
    dispatch(
      getAllMachineData({
        endPoint: `machine/list`,
      })
    );
    dispatch(
      getTotalEmployees({
        endPoint: `general/total-emp-count`,
      })
    );
    dispatch(
      getApprovedPendingBills({
        endPoint: `manage-bill/approved-rejected-bills`,
      })
    );
    dispatch(
      getPileDetails({
        endPoint: `piles/get-pile-overview`,
      })
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (Array.isArray(allProject)) {
      const project_id: any = allProject?.find(
        (val: any) => val?.projectName === projectName
      )?._id;
      if (project_id) {
        dispatch(
          getOverAllStatusOfProject({
            endPoint: `piles/overview?status=OVERALL_STATS&project=${project_id}`,
          })
        );
        dispatch(
          getEngineersInShift({
            endPoint: `piles/manpower/engineers-in-shift?projectId=${project_id}`,
          })
        );
        dispatch(getRank({ endPoint: "general/get-ranks" }));
        getWIPPilesData(project_id);
        getCompletedPiles(project_id);
        getDiscardData(project_id);
        getAllUsers(project_id);
        getPilesInfoData(project_id);
      }
    }
    // eslint-disable-next-line
  }, [projectName]);

  useEffect(() => {
    if (allProject) {
      setProjectList(() => allProject.map((val: any) => val.projectName));
    }
  }, [allProject]);

  React.useEffect(() => {
    // -------start api call to get initial data required-----
    // ---set loader to true before api call----
    setLoading(true);
    // ----call api here--after response set loader to false---
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <Sidebar>
      {loading ? (
        <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
      ) : (
        <div className="dashboard_container mb1">
          <Grid className="dash_cards">
            <Grid className="flex_start">
              <HeadLines
                label="Total Projects"
                icon={"totalProjectIcon"}
                value={projectList ? projectList.length : 0}
                fontSize={18}
              />
              <HeadLines
                label="Total Machines"
                icon={"machineUsed"}
                value={allMachineData ? allMachineData.length : 0}
                fontSize={18}
              />
              <HeadLines
                label="Total Employees"
                icon={"employees"}
                value={totalEmployeesCount ? totalEmployeesCount : 0}
                fontSize={18}
              />
              <HeadLines
                label="Total Approved Bills"
                icon={"pending"}
                value={approved}
                fontSize={18}
              />
              <HeadLines
                label="Total Pending Bills"
                icon={"pending"}
                value={pending}
                fontSize={18}
              />
            </Grid>

            <Grid className="flex_start mt1">
              {/* ------Completed piles --- */}
              <Grid className="p1 box--shadow bg--white flex_start smallcards v-center mr-1 mb1">
                <Grid className=" mr">
                  <SVG type={"totalWorkInProgressBig"} />
                </Grid>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={18}
                  className="mb0 mt0 fw400 line-height1"
                >
                  Total Work in
                  <br />
                  Progress Piles
                  <br /> in Company: {wipCount}
                </Text>
              </Grid>
              {/* ------Total Pile Length------- */}
              <Grid className="p1 box--shadow bg--white flex_start smallcards v-center mr-1 mb1">
                <Grid className=" mr">
                  <SVG type={"completedBig"} />
                </Grid>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={18}
                  className="mb0 mt0 fw400 line-height1"
                >
                  Total Completed
                  <br />
                  Piles in Company
                  <br />: {completedCount}
                </Text>
              </Grid>
              {/* ------ Maximum No of Delay causing agency ------- */}
              <Grid className="p1 box--shadow bg--white flex_start smallcards v-center mr-1 mb1">
                <Grid className="mr">
                  <SVG type={"discardedBig"} />
                </Grid>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={18}
                  className="mb0 mt0 fw400 line-height1"
                >
                  Total Discarded/
                  <br />
                  Rejected Piles
                  <br /> in Company: {discardedCount}
                </Text>
              </Grid>
            </Grid>

            <Grid className="d-flex sb ml-1">
              <Grid className="pr_dash_cards select_Project">
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt0"
                >
                  <span className="fw500">Select Project*</span>
                </Text>
                <SelectBox
                  data={projectList}
                  placeHolder="Select Project"
                  defaultVal={projectName}
                  onChange={(e) => {
                    let target = { ...e };
                    setProjectName(target.target.value);
                  }}
                  borderColor={"primary"}
                />
              </Grid>
              <Grid className="pt_dash_cards">
                <HeadLines
                  label="Total Work In Progress Piles"
                  icon={"workInProgressSmall"}
                  value={WIPPiles ? WIPPiles.length : 0}
                  fontSize={18}
                />
              </Grid>
              <Grid className="pt_dash_cards">
                <HeadLines
                  label="Total Completed Piles"
                  icon={"completedSmall"}
                  value={
                    completedPilesTableData ? completedPilesTableData.length : 0
                  }
                  fontSize={18}
                />
              </Grid>
              <Grid className="pt_dash_cards">
                <HeadLines
                  label="Total Discarded/Rejected Piles"
                  icon={"discardedSmall"}
                  value={discardRejectPiles}
                  fontSize={18}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid className="dashboard_wrapper mt1">
            {/* ---------tab area--------- */}
            <Grid className={classes.root}>
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                <Tab label="Work In Progress Piles" {...a11yProps(0)} />
                <Tab label="Total Completed Piles" {...a11yProps(1)} />
                <Tab label="Discarded/Rejected Piles" {...a11yProps(2)} />
                <Tab label="Current Engineers at Site" {...a11yProps(3)} />
                <Tab label="Total Manpower in Project" {...a11yProps(4)} />
              </Tabs>
              {projectName !== "" ? (
                <>
                  <TabPanel value={value} index={0}>
                    <WorkInProgressPiles
                      projectName={projectName}
                      engsInShifData={engsInShifData}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <CompletedPiles projectName={projectName} />
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                    <Discarded projectName={projectName} />
                  </TabPanel>
                  <TabPanel value={value} index={3}>
                    <CurrentEngineersAtSite
                      projectName={projectName}
                      engsInShifData={engsInShifData}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={4}>
                    <TotalManpower projectName={projectName} />
                  </TabPanel>
                </>
              ) : (
                <SelectOptionMsg
                  text={`Select project to view project statistics`}
                />
              )}
            </Grid>
          </Grid>
        </div>
      )}
    </Sidebar>
  );
};

export default Dashboard;
